<template>
    <div class="header-container">
        <div class="header">
            <img alt="" class="logo_zc" src="../../../assets/img/logo_slogan.png"/>
            <div class="home flex align-center">
                <div class="service text-white margin-right-sm">
                    <i class="iconfont icon-kefu margin-right-xs text-xs"></i>客服电话：{{ service_phone }}
                </div>
                <a :href="url" class="operate">{{ back }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import {service_phone} from "@/utils/const";

export default {
    components: {},
    name: "headers",
    data() {
        return {
            service_phone: service_phone
        }
    },
    props: {
        url: {
            type: String,
            default: '/web/home'
        },
        back: {
            type: String,
            default: '返回知诚会首页'
        }
    },
    computed: {},
    created() {

    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.header-container {
    background-color: #0a2240;
    box-shadow: 0 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 100px;
        margin: 0 auto;

        .logo_zc {
            height: 46px;
        }

        .logo {
            margin: 20px 0;
            height: 59px;
            width: 59px;
            border-radius: 59px;
        }

        .title {
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            margin-left: 20px;
        }

        .home {

            .operate {
                padding: 0 20px;
                height: 40px;
                background-color: var(--orange);
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;
            }
        }
    }
}
</style>